import { create } from 'zustand';
import { getIframeModeParams } from '@/utils/iframeMode';

interface IframeModeState {
  isIframeMode: boolean;
  customerId: string;
  hasRecommendation: boolean;
  hasPersonalizedSupplementRecommendations: boolean;
  isEligibleForSupplements: boolean;
  setIframeMode: (params: {
    isIframeMode: boolean;
    customerId: string;
    hasRecommendation: boolean;
    hasPersonalizedSupplementRecommendations: boolean;
    isEligibleForSupplements: boolean;
  }) => void;
}

const initialParams = getIframeModeParams();

export const useIframeModeStore = create<IframeModeState>((set) => ({
  isIframeMode: initialParams.isIframeMode,
  customerId: initialParams.customerId || '',
  hasRecommendation: initialParams.hasRecommendation,
  hasPersonalizedSupplementRecommendations: initialParams.hasPersonalizedSupplementRecommendations,
  isEligibleForSupplements: initialParams.isEligibleForSupplements,
  setIframeMode: (params) => set(params),
}));
